<template>
	<div style="padding: 10px;min-width: 1400px;">
		<el-row :gutter="20">
			<el-col :span="6"> 
				<el-input clearable placeholder="请输入客户电话" v-model="searchInfo.customer_phone">
					<template slot="prepend">客户电话</template>
				</el-input>
			</el-col>
			<el-col :span="6"> 
				<el-input clearable placeholder="请输入客户昵称" v-model="searchInfo.customer_nickname">
					<template slot="prepend">客户昵称</template>
				</el-input>
			</el-col>
			<el-col :span="4">
				<el-select clearable style="width: 100%;" v-model="searchInfo.state" filterable placeholder="请选择优惠券状态">
				    <el-option v-for="item in stateList" :key="item.value" :label="item.label" :value="item.value"> </el-option>
				</el-select>
			</el-col>
		</el-row>
		<el-row style="margin-top: 10px;" :gutter="20">
			<el-col :span="6"> 
				<el-input clearable placeholder="请输入优惠券编码" v-model="searchInfo.code">
					<template slot="prepend">优惠券编码</template>
				</el-input>
			</el-col>
			<el-col :span="6">
				<el-date-picker v-model="searchInfo.time" value-format="yyyy-MM-dd" type="daterange"
				      start-placeholder="开始时间"  end-placeholder="结束时间" >
				</el-date-picker>
			</el-col>
			<el-col :span="7"> 
				<el-button type="primary" @click="searchCoupons" icon="el-icon-search">搜索</el-button>
				<el-button  icon="el-icon-refresh" @click="clearSearch">重置</el-button>
				<el-button type="primary" icon="el-icon-plus" @click="addCoupons">发布活动</el-button>
			</el-col>
		</el-row>
		<div style="margin-top: 10px;">
			<el-table :data="couponsList"  style="width: 100%"  height="700">
				<el-table-column fixed="left" prop="customer_phone" label="客户电话" width="110" align="center"></el-table-column>
			    <el-table-column prop="customer_nickname" label="客户昵称" width="120" align="center"></el-table-column>
				<el-table-column prop="code" label="编码" width="170" align="center"></el-table-column>
				<el-table-column prop="category" label="分类" width="80" align="center"></el-table-column>
			    <el-table-column prop="typename" label="活动类型" width="80" align="center"></el-table-column>
				<el-table-column prop="userange" label="使用范围" width="80" align="center"></el-table-column>
				<el-table-column prop="validtime" label="活动时间" width="180" align="center"></el-table-column>
				<el-table-column prop="content" label="优惠内容" width="80" align="center"></el-table-column>
				<el-table-column prop="statename" label="状态" width="80" align="center"></el-table-column>
				<el-table-column prop="op" label="操作" width="80" align="center">
					<template slot-scope="scope">
						<a v-show="scope.row.state == 'notuse'" @click="deleteCoupons(scope.$index, scope.row)" title="删除优惠券" style="cursor:pointer;margin-left: 10px;color: #F56C6C;">
							<i class="el-icon-delete">删除</i>
						</a>
					</template>
				</el-table-column>
			</el-table>
		</div>
		<div style="text-align: center;">
			<el-pagination background layout="total, prev, pager, next, sizes" :page-sizes="[10, 20, 50]" :current-page="param.page"
				:page-size="param.pagenum" :total="couponsTotal" @size-change="handleSizeChange" @current-change="handleCurrentChange"> </el-pagination>
		</div>
		<el-dialog @close="refrashData" :destroy-on-close="false" :title="detailTitle" :width="dialogWidth" :visible.sync="couponsdetailShow">
			<AddCoupons v-if="showtype == 'add'" @couponNeedRefrash="needRefrash"></AddCoupons>
		</el-dialog>
		
	</div>
</template>

<script>
	import dayjs from 'dayjs'
	import AddCoupons from './addcoupons.vue'
	import {queryCustomerCouponsLists, deleteCustomerCoupon} from '/static/apiUrl.js'
	export default {
		name : 'CustomerCouponList',
		data() {
			return {
				couponsdetailShow: false,
				detailTitle:"",
				dialogWidth : '70%',
				showtype: '',			
				typeList : [
					{
						label : '所有优惠券类型',
						value : 'all',
					},
					{
						label : '现金',
						value : 'cash',
					},
					{
						label : '折扣',
						value : 'discount',
					},
					{
						label : '满减',
						value : 'fullreduction',
					},
				],
				stateList : [
					{
						label : '所有',
						value : 'all',
					},
					{
						label : '已领用',
						value : 'notuse',
					},
					{
						label : '已使用',
						value : 'used',
					},
{
						label : '已过期',
						value : 'overd',
					},
				],
				searchInfo: {
					customer_phone: '',
					customer_nickname : '',
					code : '',
					state: '',
					begin : '',
					end : '',
				},
				param : {
					page : 1,
					pagenum : 10,
				},
				selectcoupon : null,
				couponsTotal : 0,
				couponsList : []
			}
		},
		mounted() {
			//console.log('menu')
			this.searchCoupons()
		},
		methods: {
			handleSizeChange(val){
				console.log(val);
				this.param.pagenum = val;
				this.queryCoupons()
			},
			handleCurrentChange(val){
				console.log(val);
				this.param.page = val
				this.queryCoupons()
			},
			deleteCoupons(idx,row){
				//console.log(idx,row)
				this.$confirm('确定要删除未使用的优惠券吗?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning',
					center: true
				}).then(() => {
					deleteCustomerCoupon({
						code: row.code,
						customid: row.customid
					}).then(res => {
						if(0 == res.code){
							this.queryCoupons()
							this.$message({
								type: 'success',
								message: '删除成功!'
							});
						}else{
							this.$message({
								type: 'error',
								message: res.msg
							});
						}
					})
				}).catch(() => {
					
				});
			},
			searchCoupons(){
				console.log(this.searchInfo)
				this.param.page = 1
				this.queryCoupons()
			},
			queryCoupons() {
				this.couponsList = []
				queryCustomerCouponsLists({
					customer_phone: this.searchInfo.customer_phone,
					customer_nickname: this.searchInfo.customer_nickname,
					code: this.searchInfo.code,
					state: this.searchInfo.state,
					begin: this.searchInfo.time ? this.searchInfo.time[0] + ' 00:00:00' : '',
					end: this.searchInfo.time ? this.searchInfo.time[1] + ' 23:59:59': '',
					offset : (this.param.page - 1) * this.param.pagenum,
					limit : this.param.pagenum
				}).then(res => {
					if(0 == res.code){
						console.log(res)
						this.couponsTotal = res.data.total
						if(res.data.data){
							res.data.data.forEach((item) => {
								this.couponsList.push({
									customid: item.coupons_customid,
									customer_phone: item.customer_phone,
									customer_nickname: item.customer_nickname,
									code: item.coupons_code,
									type: item.coupons_type,
									typename: this.getCouponsTypeName(item.coupons_type),
									category: item.coupons_category == "platform" ? '平台' : "商家",
									userange: item.coupons_category == "platform" ? '所有档口' : "",
									validtime: dayjs(item.coupons_begintime).format('YYYY-MM-DD') + ' ~ ' + dayjs(item.coupons_overtime).format('YYYY-MM-DD'),
									content: this.getCouponsContext(item.coupons_type, item),
									discount: item.coupons_deductionamount,
									percent: item.coupons_discountratio,
									fullreduct: item.coupons_fullreduction,
									state: item.coupons_state,
									statename: this.getStateName(item.coupons_state),
								})
							})
						}
					}
				})
			},
			getCouponsTypeName(val){
				if('cash' == val){
					return '现金'
				}else if('discount' == val){
					return '折扣'
				}else if('fullreduction' == val){
					return '满减'
				}
				return ''
			},
			getStateName(val){
				if('notuse' == val){
					return '已领用'
				}else if('used' == val){
					return '已使用'
				}else if('overd' == val){
					return '已过期'
				}
				return ''
			},			
			getCouponsContext(type,val){
				if('cash' == type){
					return '抵扣' + val.coupons_deductionamount+'元'
				}else if('discount' == type){
					return val.coupons_discountratio+'折'
				}else if('fullreduction' == type){
					try{
						let temp = val.coupons_fullreduction.split("-")
						return '满 '+temp[0]+' 减 '+temp[1]
					}catch(e){ console.log(e) }
				}
				return ''
			},
			addCoupons(){
				this.detailTitle = '发放客户优惠券'
				this.selectcoupon = null
				this.showtype = "add"
				this.dialogWidth = '50%'
				this.couponsdetailShow = true
			},
			refrashData() {
				this.searchCoupons()
			},
			needRefrash(val) {
				if(val){
					this.couponsdetailShow = false
				}
			},
			clearSearch() {
				this.searchInfo.customer_phone = '' 
				this.searchInfo.customer_nickname = ''
				this.searchInfo.code = ''
				this.searchInfo.state = ''
				this.searchInfo.begin = ''
				this.searchInfo.end = ''
			}
		},
		components: {
			AddCoupons
		},
		beforeDestroy() {
			
		},
	}
</script>

<style scoped>
	
</style>